import { theme } from 'src/config';
import styled from 'styled-components' 

export const TableRow = styled.tr`
  border-top: 1px solid ${theme.color.primaryBorder};
  height:     6rem;

&:first-child {
  border-top: none;
}

:hover {
  background-color: ${theme.color.slate2};
}
`;